import { UserCircleIcon } from '@heroicons/react/outline';
import React from 'react';
import { colors } from '../style/colors';
import { appendClassProps } from '../util';
function hash(input) {
    var h = 5381; // magic number for less collisions
    for (let i = 0; i < input.length; i++) {
        var ascii = input.charCodeAt(i); // grab ASCII integer
        h = (h << 5) + h + ascii; // bitwise operations
    }
    return Math.abs(h & 0xffffffff);
}
function getUniquePalletteColor(unique) {
    const digest = hash(unique);
    const highShade = '700';
    const lowShade = '400';
    const colorChoices = [
        colors.pink[highShade],
        colors.pink[lowShade],
        colors.pink['900'],
        colors.purple[highShade],
        colors.purple[lowShade],
        colors.purple['800'],
        colors.blue[highShade],
        colors.blue[lowShade],
        colors.indigo[highShade],
        colors.indigo[lowShade],
        colors.emerald['500'],
        colors.emerald['800'],
        colors.amber['900'],
        colors.orange[highShade],
        colors.orange[lowShade],
        colors.red[highShade],
        colors.red[lowShade]
    ];
    const numberColors = colorChoices.length;
    const index = digest % numberColors;
    const randomColor = colorChoices[index];
    return randomColor;
}
/**
 - Use avatar to generate a unique avatar for a user who has no image
 */
export const Avatar = ({ className, initials, uniqueId }) => {
    const backgroundColor = getUniquePalletteColor(uniqueId ?? '');
    if (!initials) {
        return (React.createElement(UserCircleIcon, { className: `w-6 h-6 text-blue-800${appendClassProps(className)}` }));
    }
    return (React.createElement("div", { className: `rounded-full flex flex-col items-center justify-center text-white${appendClassProps(className)}`, "data-testid": "avatar", style: {
            backgroundColor
        } }, initials));
};
export * from './index.types';
//# sourceMappingURL=index.js.map